import { toThousands } from '../Service/Utils'

import React from 'react';


// import the core library.
//import ReactEchartsCore from 'echarts-for-react/lib/core';
import ReactEcharts from 'echarts-for-react';

// then import echarts modules those you have used manually.
//import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
//import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/pie';
// import 'echarts/lib/chart/scatter';
// import 'echarts/lib/chart/radar';

// import 'echarts/lib/chart/map';
// import 'echarts/lib/chart/treemap';
// import 'echarts/lib/chart/graph';
// import 'echarts/lib/chart/gauge';
// import 'echarts/lib/chart/funnel';
// import 'echarts/lib/chart/parallel';
// import 'echarts/lib/chart/sankey';
// import 'echarts/lib/chart/boxplot';
// import 'echarts/lib/chart/candlestick';
// import 'echarts/lib/chart/effectScatter';
// import 'echarts/lib/chart/lines';
// import 'echarts/lib/chart/heatmap';

// import 'echarts/lib/component/graphic';
// import 'echarts/lib/component/grid';
// import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/polar';
// import 'echarts/lib/component/geo';
// import 'echarts/lib/component/parallel';
// import 'echarts/lib/component/singleAxis';
// import 'echarts/lib/component/brush';

import 'echarts/lib/component/title';

// import 'echarts/lib/component/dataZoom';
// import 'echarts/lib/component/visualMap';

// import 'echarts/lib/component/markPoint';
// import 'echarts/lib/component/markLine';
// import 'echarts/lib/component/markArea';

// import 'echarts/lib/component/timeline';
// import 'echarts/lib/component/toolbox';

// import 'zrender/lib/vml/vml';

// The usage of ReactEchartsCore are same with above.

class BarChart extends React.Component {

    render() {
        return <ReactEcharts option={this.makeOption(this.props.dataSource)} />
    }

    makeOption(chart) {
        let formatter = undefined;

        let data = [];
        switch (chart.valueType) {
            case 'ABSOLUTE':
                data = chart.result.items.map(item => item.value);
                formatter = '{value}人'
                break;
            case 'PERCENT':
            default:
                data = chart.result.percent.map(item => item.value.toFixed(2));
                formatter = '{value}%'
                break;
        }
        return {
            tooltip: {
                trigger: 'axis',
                //formatter: (params) => `${params.data.name}\n${params.data.value}% (${values[params.dataIndex]})`,
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: (params) => {
                    const percent = params[0].value;
                    const value = toThousands(chart.result.items[params[0].dataIndex].value);
                    return `${params[0].name}: ${value}人 ${percent}%`
                }
            },
            grid: {
                top: '3%',
                left: '3%',
                right: '17%',
                bottom: '10%',
                containLabel: true
            },
            yAxis: [
                {
                    type: 'category',
                    data: chart.result?.items?.map(item => item.key)
                }
            ],
            xAxis: {
                type: 'value',
                axisLabel: {
                    formatter: formatter
                }
            },
            series: [
                {
                    name: '人群数量',
                    type: 'bar',
                    barWidth: '60%',
                    itemStyle: {
                        color: '#038BFF'
                    },
                    label: {
                        show: true,
                        position: 'right',
                        formatter: (params) => {
                            const value = toThousands(chart.result.items[params.dataIndex].value);
                            const percent = chart.result.percent[params.dataIndex].value.toFixed(2);
                            return `${value}人 ${percent}%`;
                        }
                    },
                    data: data
                }
            ]
        };
    }
}

class PieChart extends React.Component {

    render() {
        return <ReactEcharts option={this.makeOption(this.props.dataSource)} />
    }

    makeOption(chart) {
        return {
            grid: {
                top: '3%',
                left: '3%',
                right: '4%',
                bottom: '10%',
                containLabel: true
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const percent = params.data.value.toFixed(2);
                    const value = toThousands(chart.result.items[params.dataIndex].value);
                    return `${params.data.name}: ${value}人 ${percent}%`
                }
            },
            legend: {
                orient: 'vertical',
                left: 'left',
            },
            series: [
                {
                    name: '百分比',
                    type: 'pie',
                    radius: '50%',
                    data: chart.result.percent.map(item => { return { name: item.key, value: item.value } }),
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        show: true,
                        formatter: (params) => {
                            const percent = params.data.value.toFixed(2);
                            return `${params.data.name} ${percent}%`
                        }
                    }
                }
            ]
        };
    }
}

class RingChart extends React.Component {

    render() {
        return <ReactEcharts option={this.makeOption(this.props.dataSource)} />
    }

    makeOption(chart) {
        return {
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    const value = toThousands(chart.result.items[params.dataIndex].value);
                    const percent = params.data.value.toFixed(2);
                    return `${params.data.name}: ${value}人 ${percent}%`
                }
            },
            grid: {
                top: '3%',
                left: '3%',
                right: '4%',
                bottom: '10%',
                containLabel: true
            },
            legend: {
                orient: 'vertical',
                top: '5%',
                left: 10
            },
            series: [
                {
                    name: chart.name,
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    label: {
                        show: true,
                        formatter: (params) => {
                            const percent = params.data.value.toFixed(2);
                            return `${params.data.name} ${percent}%`
                        }
                    },
                    data: chart.result.percent.map(item => { return { name: item.key, value: item.value } })
                }
            ]
        };
    }
}

export { PieChart, BarChart, RingChart };